import qs from 'qs'

export const queryOnlineExhibitionsPage = () => {
  const query = qs.stringify(
    {
      fields: ['title'],
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `online-exhibitions-page?${query}`
}
